import type { DriveStep } from 'driver.js';

const at = (id: string) => `[data-tour="${id}"]`;

/**
 * "Tour this page" for My Account (/account and /profile → ProfilePage.tsx). The wallet/card
 * anchors live in BillingPaymentsTab.tsx and only render on the Billing & Payments tab; on the
 * Profile tab those steps are skipped.
 */
export function getAccountTourSteps(): DriveStep[] {
  return [
    {
      popover: {
        title: 'My Account',
        description:
          'Your personal profile — the name, photo and license details shown on your site — plus ' +
          'your saved cards and AI credits.',
      },
    },
    {
      element: at('account-tabs'),
      popover: {
        title: 'Profile or Billing & Payments',
        description:
          'Profile holds your details. Billing & Payments holds your cards, your wallet of AI ' +
          'credits, and a link to change your plan.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('account-headshot'),
      popover: {
        title: 'Your headshot',
        description: 'Click “Upload photo” or drag one in. JPG or PNG, up to 5 MB.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('account-basics'),
      popover: {
        title: 'Your details',
        description:
          'Your name, phone and a short bio. Your login email can’t be changed here — contact ' +
          'support for that.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('account-details'),
      popover: {
        title: 'License and brokerage',
        description: 'Your license number and state, brokerage name and MLS ID.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('account-notifications'),
      popover: {
        title: 'Notification preferences',
        description:
          'Choose whether we email you about new leads, send a weekly stats digest, and share ' +
          'product updates.',
        side: 'top',
        align: 'start',
      },
    },
    {
      element: at('account-save'),
      popover: {
        title: 'Save',
        description:
          'Click Save Profile when you’re done, then publish your site so visitors see your ' +
          'updated details.',
        side: 'top',
        align: 'end',
      },
    },
    {
      element: at('account-wallet'),
      popover: {
        title: 'Your wallet',
        description:
          'Add AI credits here ($10, $25, $50 or $100). Credits are only used once your monthly ' +
          'plan allowance is spent. Below it you can choose a hard limit or auto-reload.',
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: at('account-cards'),
      popover: {
        title: 'Payment methods',
        description: 'Add or remove a card, and choose which one is your default.',
        side: 'top',
        align: 'start',
      },
    },
  ];
}
